import './row.css';
import Tooltip from './../Tooltip';
import Model from '../../model/caravan';
import Attributes from '../../model/caravan/attributes';
import Buttons from './buttons';

const bonusLbl = (bonus, format = (amt, res) => `+${amt} ${res}`) => {
	return Object.keys(bonus)
		.map((res) => format(bonus[res], res))
		.join(', ');
};

const negativeFmt = (amt, res) => `-${amt} ${res}`;
const attributeFormat = (amt, res) => {
	const pct = amt - 1;
	if (pct === 0) return null;

	const sign = pct > 0 ? '+' : '';
	return `${sign}${Math.floor(pct * 100)}% ${res}`;
};

const description = (job) => {
	const bonuses = Model.Background[job];

	const message = [];
	Object.keys(bonuses).forEach((bonus) => {
		if (!Attributes[bonus]) return;

		let label = '';
		let text = null;
		if (Attributes[bonus].isAdditive) {
			const negative =
				bonus === Attributes.resilience.name ? negativeFmt : undefined;
			const value = bonusLbl(bonuses[bonus], negative);
			if (!value) return;

			label = `${bonus}: `;
			text = `[${value}]`;
		} else {
			text = bonusLbl(bonuses[bonus], attributeFormat);
		}

		if (!text) return;

		message.push([[label, text]]);
	});

	return message;
};

const row = ({
	count,
	i,
	job,
	withButtons,
	isFull,
	onIncrease,
	onDecrease,
}) => {
	return (
		<div key={i} className="row">
			<div className="row_key">{job}</div>
			<div className="row_val">
				<span>{count}</span>
				{!withButtons && (
					<Buttons
						onIncrease={onIncrease}
						onDecrease={onDecrease}
						isAtMax={isFull}
						isAtMin={count === 0}
					/>
				)}
			</div>
			<Tooltip entries={description(job)} className="row_tooltip" />
		</div>
	);
};

export default row;
